import React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { EmptyListPage, TableHeader } from "../../commons";
import CheckListModalData from "./CheckListModalData";
import {
  AllOpenJobChecklistDataType,
  JobSingleType,
} from "../../../commonTypes/jobsType";

import { OverlayTrigger, Tooltip } from "react-bootstrap";
import CheckListModalViewcontainer from "./CheckListModalViewcontainer";

type AppProps = {
  modal: boolean;
  setModal: React.Dispatch<React.SetStateAction<boolean>>;
  data: AllOpenJobChecklistDataType[] | [];
  history?: any;
  jobSingleData: JobSingleType | null;
  handleSearch: (e: any) => void;
  fetchChecklistData: (searchData?: string) => void;
  dispatchResetAllOpenJobChecklistSingleData: () => void;
  isAllOpenJobCheckListDetailPresent?: boolean;
  checklistSearchData: string
};

const ChecklistModal = ({
  modal,
  setModal,
  data,
  history,
  jobSingleData,
  fetchChecklistData,
  handleSearch,
  dispatchResetAllOpenJobChecklistSingleData,
  isAllOpenJobCheckListDetailPresent,
  checklistSearchData
}: AppProps) => {
  const toggle = () => {
    setModal((prev: boolean) => !prev);
  };


  const renderTooltip = (props: any, data: any) => {
    return (
      <Tooltip id="button-view-open-item" {...props}>
        {data}
      </Tooltip>
    );
  };

  return (
    <div>
      <Modal centered isOpen={modal} toggle={toggle} size="m" backdrop="static">
        <ModalHeader
          className="pt-3 pl-4"
          id="cross-cut"
          toggle={toggle}
          style={{ paddingBottom: "13px" }}
        >
          <div>View Checklist</div>
        </ModalHeader>
        <ModalBody className="jobsType job_checklist p-0">

          <CheckListModalViewcontainer
            data={data}
            jobSingleData={jobSingleData}
            handleSearch={handleSearch}
            fetchChecklistData={fetchChecklistData}
            dispatchResetAllOpenJobChecklistSingleData={dispatchResetAllOpenJobChecklistSingleData}
            isAllOpenJobCheckListDetailPresent={isAllOpenJobCheckListDetailPresent}
            emptyImageSize="60%"
            history={history}
            checklistSearchData={checklistSearchData}
          />

        </ModalBody>
      </Modal>
    </div>
  );
};

export default ChecklistModal;
